import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ExChange from "./exChange";
import ExChangeDetail from "./exChangeDetail";
import ConfigPage from "./configPage";
import LuckyRecord from "./luckyRecord";
import ActivityDetail from "./activityDetail";
import ActivityDetailPage from "./activityDetailPage";
import MyTeam from "./myTeam";
import RankingLuckyRecord from "./rankingLuckyRecord";
import DetailPage from "./detailPage";
import RankingDetail from "./configPage/components/ranking/rankingDetail";
import ExpiredPage from "./expired-page";

import "./index.less";
import { ReactNode, useEffect } from "react";
import Cookie from "js-cookie";
import { getQueryHashString } from "@/utils/url";
import useScrollPassIssue from "@/hooks/useScrollPassIssue";
import useHostLoginGuard from "@/hooks/useHostLoginGuard";

/**
 * 允许在宿主未登录时访问的路由。
 *
 * 白名单而非黑名单：默认受保护，新增路由自动继承"必须登录"，避免漏配成安全缺口。
 * - /configPage：专题页支持后台配置游客访问，有自己的 guest 降级逻辑（useConfigPage.ensureLogin）
 * - /expiredPage：活动过期提示页，无业务数据，不该因为未登录再弹一次登录
 */
const HOST_LOGIN_EXEMPT_ROUTES = ["/configPage", "/expiredPage"];

/**
 * 宿主未登录守卫。
 *
 * H5 侧 goToPage / goToPageV2 拼小程序跳转时 appId 恒为空，小程序的 getCode() 登录门禁
 * 不会执行，因此"退登 → 游客态专题页 → 跳 exChangeDetail 等页面"会在未登录状态下直接打开
 * 它们，而 webview 内的 cookie 仍是退登前的旧 uid。这里统一拦一道，交还宿主登录页。
 */
function HostLoginGuard({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const blocked = useHostLoginGuard({
    skip: HOST_LOGIN_EXEMPT_ROUTES.includes(pathname),
  });
  if (blocked) {
    return null;
  }
  return <>{children}</>;
}

function App() {
  useScrollPassIssue();

  // 开发模式配置
  useEffect(() => {
    const mode = import.meta.env.MODE;
    console.log("本地开发模式 ===> ", mode);
    if (["test", "uat"].includes(mode)) {
      const uid = getQueryHashString("uid");
      if (uid) {
        Cookie.set("wasxuid_r", uid);
        Cookie.set("isTest", true);
      }
    } else {
      Cookie.set("isTest", "");
    }
  }, []);
  return (
    <Router>
      <HostLoginGuard>
        <Routes>
          <Route path="/" element={<ExChange />} />
          <Route path="/exChange" element={<ExChange />} />
          <Route path="/exChangeDetail" element={<ExChangeDetail />} />
          <Route path="/configPage" element={<ConfigPage />} />
          <Route path="/luckyRecord" element={<LuckyRecord />} />
          <Route path="/activityDetail" element={<ActivityDetail />} />
          <Route path="/activityDetailPage" element={<ActivityDetailPage />} />
          <Route path="/myTeam" element={<MyTeam />} />
          <Route path="/rankingLuckyRecord" element={<RankingLuckyRecord />} />
          <Route path="/detailPage" element={<DetailPage />} />
          <Route path="/rankingDetail" element={<RankingDetail />} />
          <Route path="/expiredPage" element={<ExpiredPage />} />
        </Routes>
      </HostLoginGuard>
    </Router>
  );
}

export default App;
